/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CDKModule} from '../../cdk.module';
import {MaterialModule} from '../../material.module';
import {InputPhoneNumbersComponent} from './input-phone-numbers/input-phone-numbers.component';
import {InputCommentsComponent} from './input-comments/input-comments.component';
import {InputGeneralConditionsComponent} from './input-general-conditions/input-general-conditions.component';
import {InputQuantityComponent} from './input-quantity/input-quantity.component';
import {InputWeightComponent} from './input-weight/input-weight.component';
import {InputAnimalNumberComponent} from './input-animal-number/input-animal-number.component';
import {InputAnimalNumberSplitComponent} from './input-animal-number-split/input-animal-number-split.component';
import {InputNameComponent} from './input-name/input-name.component';
import {InputTownshipComponent} from './input-township/input-township.component';
import {InputAddressComponent} from './input-address/input-address.component';
import {InputPasswordComponent} from './input-password/input-password.component';
import {InputEmailComponent} from './input-email/input-email.component';
import {InputUsernameComponent} from './input-username/input-username.component';

@NgModule({
  declarations: [
    InputAddressComponent,
    InputAnimalNumberComponent,
    InputAnimalNumberSplitComponent,
    InputCommentsComponent,
    InputEmailComponent,
    InputGeneralConditionsComponent,
    InputNameComponent,
    InputPasswordComponent,
    InputPhoneNumbersComponent,
    InputQuantityComponent,
    InputTownshipComponent,
    InputUsernameComponent,
    InputWeightComponent
  ],

  exports: [
    InputAddressComponent,
    InputAnimalNumberComponent,
    InputAnimalNumberSplitComponent,
    InputCommentsComponent,
    InputEmailComponent,
    InputGeneralConditionsComponent,
    InputNameComponent,
    InputPasswordComponent,
    InputPhoneNumbersComponent,
    InputQuantityComponent,
    InputTownshipComponent,
    InputUsernameComponent,
    InputWeightComponent
  ],
  imports: [
    CDKModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule
  ]
})

export class InputsModule {
}
